import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.75 10.25V8c0-3.17-2.58-5.75-5.75-5.75S6.25 4.83 6.25 8v2.25c-1.65.17-3 1.61-3 3.25V19c0 1.79 1.46 3.25 3.25 3.25h11c1.79 0 3.25-1.46 3.25-3.25v-5.5c0-1.64-1.35-3.08-3-3.25M7.75 8A4.26 4.26 0 0 1 12 3.75 4.26 4.26 0 0 1 16.25 8v2.25h-8.5zm11.5 11c0 .96-.79 1.75-1.75 1.75h-11c-.96 0-1.75-.79-1.75-1.75v-5.5c0-.96.79-1.75 1.75-1.75h11c.96 0 1.75.79 1.75 1.75z" }, null, -1),
    _createElementVNode("path", { d: "M12 18c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0-2.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5" }, null, -1)
  ]))]))
}
export default { render: render }